"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = formatPhoneNumber;
/**
 * Format phone number for display
 * Converts +1XXXXXXXXXX to +1 (XXX) XXX-XXXX
 *
 * @param phoneNumber - Phone number in E.164 format (e.g., +15551234567)
 * @returns Formatted phone number for display
 */
function formatPhoneNumber(phoneNumber) {
    // Format +1XXXXXXXXXX to +1 (XXX) XXX-XXXX for display
    if (phoneNumber.startsWith('+1') && phoneNumber.length === 12) {
        const digits = phoneNumber.slice(2);
        return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return phoneNumber;
}
